import TabsElement from './TabsElement';
import TabsElementPresets from './TabsElementPresets';
import TabsElementChildPresets from './TabsElementChildPresets';
import TabsElementMetaData from './TabsElementMetaData';
import TabsElementProps from './TabsElementProps';
import { DATA_PANELS } from 'crazyEditor/core/constants/panelConstants';

export default {
  metaData: TabsElementMetaData,
  elementClass: TabsElement.elementClass,
  elementProps: TabsElementProps,
  presets: TabsElementPresets,
  childPresets: TabsElementChildPresets,
  panel: DATA_PANELS.TABS,
  methods: TabsElement.methods,
};
